import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import './style.scss';
import { FormControl } from '@mui/base';
import Select from '@mui/material/Select';
import { Button, FormControlLabel, MenuItem, TextField, CircularProgress, IconButton, Menu, Checkbox, RadioGroup, Radio, Tooltip } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';
import CheckBox from '@mui/material/Checkbox';
import OpenProjectCreateTaskDialog from '../../components/openProject/createOpenProjectTaskDialog';
import { setFilterIssueCompleteShow, setFilterIssueTypeId, setSearchIssueText, setShowPendingTasks, setShowCompletedTasks, setStartDate, setEndDate, setAllOpen, setCreatedBy, setOverDue, setRecentlyCreated } from '../../store/projectSlice';
import { getOpenProjectTypes, getUserNotification } from '../../services/openProject.service';
import CreateJiraTaskDialog from '../../components/task/createJiraTaskDialog';
import { dropDownMenuProps } from '../../utils/components';
import { ProjectContext } from '../Homepage';
import { downloadUserReport } from '../../services/user.service';
import { CHAT_BOT_KNOWLEDGE_BASE_URL, ORG_CHART_BASE_URL, ORG_CHART_BASE_URL_ID, COMMON_LANDING_PAGE_BASE_URL } from '../../services/const';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { useTheme } from '@mui/material/styles';
import { DateRangePicker } from "rsuite";
import { DateRange } from "rsuite/esm/DateRangePicker";
import moment from 'moment';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import { clearSession } from '../../App';
import { setUserOpSession, setUserJiraSession } from '../../store/userSlice';
import { setTrackingState } from '../../store/trackingSlice';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import WayMoreProjectLoginComponent from '../../components/openProjectLoginUi/loginComponent';
import JiraLoginComponent from '../../components/JiraLoginUi/jiraLoginComponent';
import NotificationPopOver from '../../components/popup/notificationPopOver';
import NotesPopup from '../../components/NotesPopup/NotesPopup';


const IssueFilterPage = ({ setIssueRefetch }: { setIssueRefetch: React.Dispatch<React.SetStateAction<boolean>> }) => {

  const projectState = useSelector((state: RootState) => state.project);
  const userState = useSelector((state: RootState) => state.user);
  const userDetails = userState?.user;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dateRange, setDateRange] = useState<[Date, Date] | null>(null);
  const disableFutureDates = (date: Date) => moment(date).isAfter(moment().endOf("day"));

  const [menus, setMenus] = useState([{ name: 'All Issues', id: 'ALL' }]);
  const [selectedMenu, setSelectedMenu] = useState<any>(menus[0]);
  const [searchIssue, setSearchIssue] = useState<string>('');
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isOpenProjectCreateTaskOpen, setIsOpenProjectCreateTaskOpen] = useState<boolean>(false);
  const [isJiraCreateTaskOpen, setIsJiraCreateTaskOpen] = useState<boolean>(false);
  const [jiraAccessToken, setJiraAccessToken] = useState('');
  const [openProjectAccessToken, setOpenProjectAccessToken] = useState('');
  const [isSearchInputFocused, setIsSearchInputFocused] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [notificationContent, setNotificationContent] = useState([])
  const projectName = projectState?.selectedProject?.name
  const projectSelectedProject = projectState.selectedProject;
  const projectTypeMenu = projectState.projectTypeMenu
  const projectType = projectState.projectType

  const { jiraProjectList, projectList } = useContext(ProjectContext);
  const [jiraProjects, setJiraProjects] = useState(jiraProjectList);
  const [opProjectList, setOpProjectList] = useState(projectList);
  const [isNotesPopup, setIsNotesPopup] = useState<boolean>(false);

  const user = sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user") || '') : {};

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [filters, setFilters] = useState({
    selectedFilter: '',
    pendingTasks: false,
    completedTasks: false,
    createdBy: false,
    allOpen: false,
    recentlyCreated: false,
    overDue: false,
    filterOption: '',
  });
  const theme = useTheme();
  const opSessionId = useSelector((state: RootState) => state.user.opSessionId);
  const jiraSessionId = useSelector((state: RootState) => state.user.jiraSessionId);

  const handleFilterOffClick = () => {
    const initialFilters = {
      selectedFilter: '',
      pendingTasks: false,
      completedTasks: false,
      createdBy: false,
      allOpen: false,
      recentlyCreated: false,
      overDue: false,
      filterOption: '',
    };

    setFilters(initialFilters);
    dispatch(setShowCompletedTasks(false));
    dispatch(setShowPendingTasks(false));
    dispatch(setAllOpen(false));
    dispatch(setRecentlyCreated(false));
    dispatch(setCreatedBy(false));
    dispatch(setOverDue(false));

    setAnchorEl(null);
  };

  const handleOptionClick = (option: any) => {

    setFilters({
      ...filters,
      filterOption: option,
      pendingTasks: option === 'pendingTasks',
      completedTasks: option === 'completedTasks',
      createdBy: option === 'createdBy',
      allOpen: option === 'allOpen',
      recentlyCreated: option === 'recentlyCreated',
      overDue: option === 'overDue',
    });

  };
  const handleClose = () => {
    dispatch(setShowCompletedTasks(filters.completedTasks));
    dispatch(setShowPendingTasks(filters.pendingTasks));
    dispatch(setAllOpen(filters.allOpen));
    dispatch(setRecentlyCreated(filters.recentlyCreated));
    dispatch(setCreatedBy(filters.createdBy));
    dispatch(setOverDue(filters.overDue));
    setAnchorEl(null);
  };
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);

  };

  const handleCreateOpenProjectTaskDailogClose = (isTaskCreated: boolean = true) => {
    setIssueRefetch(isTaskCreated);
    setIsOpenProjectCreateTaskOpen(false)
  }

  const handleCreateJiraTaskDailogClose = useCallback((isTaskCreated: boolean = true) => {
    setIssueRefetch(isTaskCreated);
    setIsJiraCreateTaskOpen(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreateNewTaskDialogOpen = () => {
    if (projectType === projectTypeMenu[0]) {
      setIsOpenProjectCreateTaskOpen(true)
    } else if (projectType === projectTypeMenu[2]) {
      setIsJiraCreateTaskOpen(true);
    }
  }

  const handleCreateNewTaskButtonDisable = () => {
    if (projectType === projectTypeMenu[0] || projectType === projectTypeMenu[2]) {
      return projectSelectedProject?.id ? false : true
    }
    return true
  }

  const setIssueTypeDropdownList = (issuetypeList: { name: string, id: string }[]) => {
    issuetypeList.unshift(menus[0]);
    setSelectedMenu(menus[0]?.id);
    dispatch(setFilterIssueTypeId(menus[0]?.id))
    setMenus(issuetypeList);
  }

  const listJiraTaskIssueType = async () => {
    let jiraProjectData = []
    try {
      if (userDetails?.jiraDetails?.accountId) {
        jiraProjectData = jiraProjects.length ? jiraProjects : jiraProjectList;
      }
    } catch (error) {
      jiraProjectData = []
    }

    const projectTasks: any[] = []
    if (Array.isArray(jiraProjectData) && jiraProjectData.length) {
      for (const project of jiraProjectData) {
        projectTasks.push(...project?.issueTypes)
      }
    }

    const typeData = projectTasks.filter((projectTask, index, self) => {
      const firstIndex = self?.findIndex((s) => {
        return s.id === projectTask?.id
      })
      return firstIndex === index
    })
    let menuList = typeData.map((e: any) => ({ name: e.name, id: e.id }));
    setIssueTypeDropdownList(menuList)
  }

  const listOpenProjectTaskIssueType = async () => {
    let opProjectData = []
    try {
      if (userDetails?.openProjectDetails?.id) {
        opProjectData = opProjectList.length ? opProjectList : projectList;
      }
    } catch (error) {
      opProjectData = []
    }

    const projectTasks: any[] = []
    if (Array.isArray(opProjectData) && opProjectData.length) {
      for (const project of opProjectData) {
        projectTasks.push(...project?.type)
      }
    }

    const typeData = projectTasks.filter((projectTask, index, self) => {
      const firstIndex = self?.findIndex((s) => {
        return s.id === projectTask?.id
      })
      return firstIndex === index
    })
    let menuList = typeData.map((e: any) => ({ name: e.name, id: e.id }));
    setIssueTypeDropdownList(menuList);
  }


  const handleSelectIssue = (event: any) => {
    // if(!isIssueTracking){ 
    setSelectedMenu(event.target.value);
    dispatch(setFilterIssueTypeId(event.target.value))
    // }else{
    //   toast('Tracker is Running')
    // }
  };

  const handleSearchIssue = (event: any) => {
    // if(!isIssueTracking){
    setSearchIssue(event.target.value);
    dispatch(setSearchIssueText(event.target.value))
    // }else{
    //   toast('Tracker is Running')
    // }
  };
  const searchIssueText = projectState?.searchIssueText;
  useEffect(() => {
    setSearchIssue(searchIssueText || "");
  }, [searchIssueText]);
  

  const handleCheck = (event: any) => {
    // if(!isIssueTracking){
    setIsChecked(event.target.checked);
    dispatch(setFilterIssueCompleteShow(event.target.checked))
    // }else{
    //   toast('Tracker is Running')
    // }
  };

  const handleDateRangeChange = (
    range: DateRange | null
  ) => {
    if (range) {
      setDateRange(range);
      dispatch(setStartDate(moment(range[0]).format('YYYY-MM-DD')))
      dispatch(setEndDate(moment(range[1]).add('days', 1).format('YYYY-MM-DD')))
    } else {
      setDateRange(null);
      dispatch(setStartDate(''))
      dispatch(setEndDate(''))
    }
  };

  useEffect(() => {
    const jiraAccessToken = localStorage.getItem('jiraAccessToken') || '';
    const openProjectAccessToken = localStorage.getItem('openProjectAccessToken') || '';

    setOpenProjectAccessToken(openProjectAccessToken);
    setJiraAccessToken(jiraAccessToken);

    if (userDetails) {
      if (projectType === projectTypeMenu[0] && openProjectAccessToken) {
        listOpenProjectTaskIssueType();
      } else if (projectType === projectTypeMenu[2] && jiraAccessToken) {
        listJiraTaskIssueType()
      } else {
        setIssueTypeDropdownList([])
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectType, userDetails])

  useEffect(() => {
    setJiraProjects(jiraProjectList);
    const jiraAccessToken = localStorage.getItem('jiraAccessToken');
    if ((projectType === projectTypeMenu[2]) && jiraAccessToken) {
      listJiraTaskIssueType()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jiraProjectList])

  useEffect(() => {
    setOpProjectList(projectList);
    const openProjectAccessToken = localStorage.getItem('openProjectAccessToken');
    if ((projectType === projectTypeMenu[0]) && openProjectAccessToken) {
      listOpenProjectTaskIssueType();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectList])

  const handleDownloadReport = async () => {
    setIsDownloading(true);
    const userNames = sessionStorage.getItem('userNameReport') ? JSON.parse(sessionStorage.getItem('userNameReport') || '[]') : [];
    try {
      await downloadUserReport(userNames);
    } catch (error) {
      console.log(error)
    } finally {
      setIsDownloading(false);
    }
  };

  const openInNewTab = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const openReport = () => {
    const userNames = sessionStorage.getItem('userNameReport') ? JSON.parse(sessionStorage.getItem('userNameReport') || '[]') : [];
    const chartId = sessionStorage.getItem("chartId") || "";
    const userId = sessionStorage.getItem("userId") || '';
    localStorage.setItem('usernames', JSON.stringify(userNames))
    localStorage.setItem('chartId', chartId)
    localStorage.setItem('userId', userId)
    const currentUser = userDetails?.userDetails?.email_address ? userDetails?.userDetails?.email_address.split('@')[0] : ""
    const newPath = `/?activity=true&currentUser=${currentUser}`;
    openInNewTab(newPath);
  }

  const openChatBot = () => {
    openInNewTab(CHAT_BOT_KNOWLEDGE_BASE_URL);
  };

  const openOrgChart = () =>{
    const chartId = sessionStorage.getItem('chartId') ? sessionStorage.getItem('chartId') : '';
    const orgChartRedirectUrl =`${ORG_CHART_BASE_URL}?chartId=${chartId}&id=${ORG_CHART_BASE_URL_ID}`
    openInNewTab(orgChartRedirectUrl)
  }

  const openCommonLandingPage = () =>{
    openInNewTab(COMMON_LANDING_PAGE_BASE_URL)
  }
  
  ///Future use
  // const handleLogout = () => {
  //   console.log("logout////")
  //   dispatch(setTrackingState(false))
  //   if (opSessionId)
  //     dispatch(setUserOpSession(null));
  //   if (jiraSessionId)
  //     dispatch(setUserJiraSession(null));
  //   clearSession();
  //   navigate('/login', { replace: true });


  //   window.history.pushState(null, "", window.location.href);
  //   window.addEventListener("popstate", () => {
  //     window.history.pushState(null, "", window.location.href);
  //   });
  // }

  const handleLogout = async () => {
    await Promise.all([
      dispatch(setTrackingState(false)),
      opSessionId ? dispatch(setUserOpSession(null)) : null,
      jiraSessionId ? dispatch(setUserJiraSession(null)) : null,
      clearSession()
    ]);

    navigate('/login', { replace: true });
  };

  const getNotifications = async () => {
    if (openProjectAccessToken) {
      try {
        const notificationResponse = await getUserNotification()
        if (notificationResponse?.data?._embedded?.elements?.length) {
          setNotificationContent(notificationResponse?.data?._embedded?.elements)
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  useEffect(() => {
    getNotifications()
    window.addEventListener('click', getNotifications)
    return () => {
      window.removeEventListener('click', getNotifications)
    }
  }, [openProjectAccessToken])

  return (
    <div className="issueFilterDiv">
      <div className="issueTitle">
        <span className="issueTitle-text">Issues</span>
        <div className='report-excel'>
          <Button variant='contained' sx={{ textTransform: 'none' }} style={{ padding:'6px 12px' }} onClick={openChatBot}>Support</Button>
          {
            user.email_address && <Button disabled={isDownloading} variant='contained' onClick={openReport} sx={{ textTransform: 'none' }} style={{padding:'4px 12px'  }}>
              Report {
                isDownloading && <CircularProgress style={{ marginLeft: '5px' }} size='1rem' />
              } </Button>
          }
          {!jiraAccessToken && <JiraLoginComponent />
          }
          {!openProjectAccessToken && <WayMoreProjectLoginComponent />
          }
          <NotificationPopOver notificationContent={notificationContent} />
          <IconButton onClick={handleLogout}
            className='logout-icon'>
            <LogoutIcon />
          </IconButton>

        </div>
      </div>
      <div className="button-container">
        <div className="project-name-container">{projectName}</div>
        <div className='report-excel'>
          <Button variant='contained' sx={{ textTransform: 'none' }} style={{ padding:'6px 12px' }} onClick={openOrgChart}>Org Chart</Button>
          <Button variant='contained' sx={{ textTransform: 'none' }} style={{ padding:'6px 12px' }} onClick={openCommonLandingPage}>Common Landing Page</Button>
        </div>
      </div>
      <div className='issueSearchDropdown'>
        <div className='issueSearchDropdown-left'>
          <FormControl>
            <Select
              sx={{ width: '150px', textAlign: 'left' }}
              size='small'
              value={selectedMenu}
              id='select-issue-menu'
              MenuProps={dropDownMenuProps}
              onChange={handleSelectIssue}
            >
              {menus.map((value, index) => (
                <MenuItem key={index} value={value?.id}>{value?.name}</MenuItem>
              ))}</Select>
          </FormControl>
          <span style={{ fontSize: 'large' }}>Filter</span>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <FilterAltIcon style={(filters.pendingTasks || filters.completedTasks) ? { color: theme.palette.primary.main } : {}} />
          </IconButton>

          {(filters.filterOption !== '') && (
            <Tooltip title="To clear filter, click here">
              <IconButton onClick={handleFilterOffClick}>
                <FilterAltOffIcon />
              </IconButton>
            </Tooltip>
          )}

          <Menu
            id="filter-menu"
            MenuListProps={{
              'aria-labelledby': 'filter-menu',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
          >
            <MenuItem
              sx={{
                '&:hover': {
                  backgroundColor: "white",
                },
              }}>
              <RadioGroup
                value={filters.filterOption}
                onChange={(event) => handleOptionClick(event.target.value)}
                name="taskFilter"
                sx={{
                  '&:hover': {
                    backgroundColor: "white",
                  },
                  width: "110%"
                }}
              >
                <FormControlLabel
                  value="pendingTasks"
                  control={<Radio />}
                  label="Show pending tasks which I assigned"
                  sx={{
                    '&:hover': {
                      backgroundColor: theme.palette.grey[100],
                    },
                    width: "110%"
                  }}
                />
                <FormControlLabel
                  value="completedTasks"
                  control={<Radio />}
                  label="Show completed tasks which I assigned"
                  sx={{
                    '&:hover': {
                      backgroundColor: theme.palette.grey[100],
                    },
                    width: "110%"
                  }}

                />

                {projectType === projectTypeMenu[0] && (
                  <>
                    <FormControlLabel
                      value="createdBy"
                      control={<Radio />}
                      label="Created by me"
                      sx={{
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                        },
                        width: "110%"
                      }}
                    />
                    <FormControlLabel
                      value="overDue"
                      control={<Radio />}
                      label="Overdue"
                      sx={{
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                        },
                        width: "110%"
                      }}
                    />
                    <FormControlLabel
                      value="recentlyCreated"
                      control={<Radio />}
                      label="Recently created"
                      sx={{
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                        },
                        width: "110%"
                      }}
                    />
                    <FormControlLabel
                      value="allOpen"
                      control={<Radio />}
                      label="All open"
                      sx={{
                        '&:hover': {
                          backgroundColor: theme.palette.grey[100],
                        },
                        width: "110%"
                      }}
                    />
                  </>
                )}
              </RadioGroup>
            </MenuItem>
          </Menu>
        </div>

        <div className='issueSearchDropdown-right'>
          <DateRangePicker
            className="date-picker-small"
            value={dateRange}
            onChange={handleDateRangeChange}
            format="yyyy-MM-dd"
            shouldDisableDate={disableFutureDates}
          />
          <Button variant="contained" sx={{ textTransform: 'none' }} onClick={() => setIsNotesPopup(true)}>Notes</Button>
          <Button disabled={handleCreateNewTaskButtonDisable()} variant="contained" onClick={handleCreateNewTaskDialogOpen} sx={{ textTransform: 'none', minWidth:'max-content', width:'max-content' }}>New Task</Button>
          <TextField id='issue-search' size='small' value={searchIssue} onInput={handleSearchIssue}
            focused={isSearchInputFocused}
            onFocus={() => setIsSearchInputFocused(true)}
            onBlur={() => setIsSearchInputFocused(false)}
            placeholder='Search Issues'
            helperText={projectType === projectTypeMenu[2] && isSearchInputFocused && "search by title or whole Key eg:ALW-12345 "}
          />
        </div>
      </div>

      {isOpenProjectCreateTaskOpen && <OpenProjectCreateTaskDialog isOpen={isOpenProjectCreateTaskOpen} onClose={handleCreateOpenProjectTaskDailogClose} />}
      <CreateJiraTaskDialog isOpen={isJiraCreateTaskOpen} onClose={handleCreateJiraTaskDailogClose} />
      {isNotesPopup && <NotesPopup open={isNotesPopup} onClose={() => setIsNotesPopup(false)} />}
    </div>
  )
}

export default IssueFilterPage
